import { API } from "@/services/api";
import { searchEndpoints } from "@/constant/endpoints";
import { buildQueryString } from "@/utils/common.utils";
import { SearchParams, SearchResponse } from "@/types/search.types";

export const getSearchResultsService = async (params: SearchParams = {}): Promise<SearchResponse> => {
  const response = await API.Get<SearchResponse>(`${searchEndpoints.search}${buildQueryString(params)}`);
  if (response.data) return response.data;
  throw new Error(response.message);
};
